import React from 'react';
import { useOptimizedImages } from 'common/hooks/use-optimized-images';
import { ImagePlaceholder, ImageFallback } from '@navi-toolbox/ui-components';
import { THUMB_HEIGHT, THUMB_GAP, thumb } from './styles';
import { Hover } from '../types';
import { useTranslation } from 'react-i18next';

export type Props = {
  src: string;
  index: number;
  onMouseEnterCb: (type: string, src: string, index: Hover) => void;
  onMouseLeaveCb: () => void;
  onClick: (mediaType: string, imgSrc: string, index: number) => void;
};

export const DATA_QA_THUMB_ITEM_IMAGE = 'thumb-item-image';

function ThumbImage({ src, index, onClick, onMouseEnterCb, onMouseLeaveCb }: Props) {
  const { t } = useTranslation();
  const imgSizes = {
    thumb: {
      h: THUMB_HEIGHT.toString(),
      w: THUMB_HEIGHT.toString(),
    },
  };
  const optimizedImage = useOptimizedImages(src, imgSizes);

  return (
    <picture>
      <source srcSet={`${optimizedImage.thumb?.xx} 2x, ${optimizedImage.thumb?.x} 1x`} />
      <ImagePlaceholder
        data-qa={DATA_QA_THUMB_ITEM_IMAGE}
        className={thumb}
        src={optimizedImage.thumb?.x || ''}
        data-src={optimizedImage.thumb?.x || ''}
        alt={`слайд ${index}`}
        loading="lazy"
        onClick={() => onClick('mediaPdpPhoto', src, index)}
        onMouseEnter={() => onMouseEnterCb('mediaPdpPhoto', src, index)}
        onMouseLeave={onMouseLeaveCb}
        fallback={
          <div style={{ paddingBottom: THUMB_GAP }}>
            <ImageFallback alt={t('ui.image.alt')} width={THUMB_HEIGHT} height={THUMB_HEIGHT} />
          </div>
        }
      />
    </picture>
  );
}

export { ThumbImage };
